import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const MicFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M12 16.45c2.31 0 4.2-1.89 4.2-4.2V6.38c0-2.31-1.89-4.2-4.2-4.2-2.31 0-4.2 1.89-4.2 4.2v5.87c0 2.31 1.89 4.2 4.2 4.2Z"
      fill={color}
    />
    <Path
      d="M17.9 11.49c-.43 0-.79.35-.79.79 0 2.82-2.29 5.11-5.11 5.11-2.82 0-5.11-2.29-5.11-5.11 0-.43-.35-.79-.79-.79-.44 0-.79.35-.79.79 0 3.42 2.58 6.24 5.9 6.63v2.15c0 .43.35.79.79.79.44 0 .79-.35.79-.79v-2.15c3.32-.39 5.9-3.21 5.9-6.63 0-.43-.35-.79-.79-.79Z"
      fill={color}
    />
  </Svg>
)

export default MicFilled
